<template>
  <div class="locations d-flex">
    <div
      class="px-1"
      v-for="layer in bus.map"
      :key="layer.title"
    >
      <div
        class="bus"
        :class="{ bus_disable: disable == 'buses' }"
      >
        <div class="bus-title">
          <span slot="title">{{ layer.title }}</span>
        </div>
        <div class="bus-caption">
          <span slot="category">{{ layer.categ_str }}</span>
        </div>
        <div
          class="bus-seats"
          :class="
            'bus-seats_' +
              layer.layout.reduce(
                (a, b) => (b instanceof Array && a < b.length ? b.length : a),
                0
              )
          "
        >
          <div class="bus-section">
            <span>FRENTE</span>
          </div>
          <table>
            <tr
              v-for="(row, r) in layer.layout"
              :key="r"
            >
              <td>{{ r + 1 }}</td>
              <template v-for="(seat, c) in row">
                <td
                  v-if="(seat instanceof Object)"
                  class="bus-seat"
                  :key="'seat_' + c"
                  @click="
                    $store.state.booking.seats.some(s => s.id == seat.id) &&
                      !seat.passenger &&
                      $emit('sit', seat)
                  "
                >
                  <div v-if="seat.passenger">
                    <span class="bus-seat-tooltip">
                      {{ seat.passenger.alt }}
                    </span>
                    <span class="bus-seat-dot" />
                  </div>
                  <seat-icon :fill="seat.fill" />
                </td>
                <td
                  v-else
                  :key="'path_' + c"
                >
                  <span class="bus-path" />
                </td>
              </template>
              <td>{{ r + 1 }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="px-1">
      <div
        class="hotels m-0"
        :class="{ hotels_disable: disable == 'hotels', hotels_hover: hover == 'hotels' }"
      >
        <div>
          <div class="hotel">
            <h4
              class="d-flex"
              v-for="hotel in hotels"
              :key="hotel.id"
            >
              <span class="hotel-name">{{ hotel.name }}</span>
              <div class="ml-auto">
                <star
                  v-for="star in hotel.stars"
                  :key="star"
                />
              </div>
            </h4>
            <div class="hotel-rooms mt-2">
              <div
                v-for="room in rooming"
                class="room"
                :key="room.tmp_id"
                @click="
                  room.capacity > room.passengers.length &&
                    $emit('distribute', room)
                "
              >
                <h3 class="room-name">
                  {{ room.name }}
                </h3>
                <img
                  class="room-ico"
                  :src="'/api/images/beds/' + room.icon"
                >
                <span
                  class="room-tooltip"
                  v-if="room.tooltip"
                >
                  {{ room.tooltip }}
                </span>
                <div class="room-dots">
                  <span
                    v-for="dot in room.passengers.length"
                    class="room-dot"
                    :key="dot"
                  />
                </div>
              </div>
            </div>
            <div class="hotel-notes">
              <input-tags
                placeholder="Observaciones"
                @input="notes => $emit('notes', { notes, hotel_id: hotel.id })"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SeatIcon from '@/components/SeatIcon'
import Star from '@/components/Star'
import InputTags from '@/components/InputTags'
import { SEAT_STATUS } from '@/constans'
import { clone } from '@/utils'

export default {
  components: { Star, SeatIcon, InputTags },

  name: 'Locations',

  computed: {
    bus () {
      const passengers = this.$store.state.booking.passengers
      const bus = this.$store.state.booking.departure.bus

      bus.map = Object.values(bus.map).map(layer => {
        layer.layout = layer.layout.map(row =>
          row
            .map(col => bus.seating[col] || col)
            .map(seat => {
              if (typeof seat === 'object') {
                seat.passenger = passengers.find(p => p.seat_id == seat.id)
                seat.fill =
									this.$store.state.booking.seats.find(s => s.id == seat.id) ||
									seat.passenger
									  ? SEAT_STATUS.picked.hex
									  : SEAT_STATUS.reserved.hex
              }
              return seat
            })
        )
        return layer
      })
      return bus
    },
    rooming () {
      const rooming = clone(this.$store.state.booking.rooming)
      const passengers = this.$store.state.booking.passengers
      return rooming.map(rooming => {
        rooming.tooltip = rooming.passengers
          .map(tmp_id => passengers.find(passenger => passenger.tmp_id == tmp_id))
          .filter(p => p)
          .map(p => p.alt)
          .join(', ')
        return rooming
      })
    },
    hotels () {
      return this.$store.state.booking.rate.hotels
    }
  },

  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      SEAT_STATUS,
      disable: null,
      hover: null
    }
  }
}
</script>
